const HIGHLIGHT = [
    {keyword: 'added', type: 'success'},
    {keyword: 'modified', type: ''},
    {keyword: 'canceled', type: 'danger'},
    {keyword: 'declined', type: 'danger'},
    {keyword: 'created', type: 'success'},
    {keyword: 'automatically accepted', type: 'success'},
    {keyword: 'manually accepted', type: 'success'},
    {keyword: 'automatically rejected', type: 'danger'},
    {keyword: 'manually rejected', type: 'danger'},
    {keyword: 'expired', type: ''},
    {keyword: 'blacklisted', type: ''},
    {keyword: 'issued', type: ''},
    {keyword: 'reissued', type: ''},
    {keyword: 'voided', type: ''},
    {keyword: 'abandoned', type: ''},
    {keyword: 'past due', type: ''},
    {keyword: 'partially paid', type: 'success'},
    {keyword: 'sent', type: ''},
    {keyword: 'paid', type: 'success'},
    {keyword: 'amount due', type: ''},
    {keyword: 'renewed', type: 'success'},
    {keyword: 'reactivated', type: 'success'},
    {keyword: 'activated', type: 'success'},
    {keyword: 'approved', type: 'success'},
    {keyword: 'partially refunded', type: ''},
    {keyword: 'refunded', type: ''},
    {keyword: 'disputed', type: 'warning'},
    {keyword: 'upgraded', type: ''},
    {keyword: 'downgraded', type: ''},
    {keyword: 'churned', type: ''},
    {keyword: 'merged', type: ''},
    {keyword: 'changed', type: ''},
    {keyword: 'deactivated', type: 'danger'},
    {keyword: 'redeemed', type: ''},
    {keyword: 'toggled on', type: 'success'},
    {keyword: 'toggled off', type: 'danger'},
];

export default HIGHLIGHT;
